import React from 'react';
import { motion } from 'framer-motion';

const OpenIcon = ({ open, variant = 'rotate', ...rest }) => {
  return (
    <motion.div
      className="open-icon"
      initial="idle"
      animate={open ? variant : 'idle'}
      variants={{
        idle: {
          rotateZ: '0deg',
        },
        rotate: {
          rotateZ: '45deg',
        },
      }}
    >
      <svg
        height="30"
        width="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <circle cx="15" cy="15" r="15" fill="#215CCC" />
        <rect width="100%" height="4px" y="13" fill="white" rx={2} ry={2} />
        <motion.rect
          variants={{
            idle: { rotateZ: '0deg' },
            collapse: { rotateZ: '90deg' },
          }}
          width="4px"
          height="100%"
          x={13}
          rx={2}
          ry={2}
          fill="white"
        />
      </svg>
    </motion.div>
  );
};

export default OpenIcon;
